import { SimulationPostprocessingStatus } from "src/clients/jobs";
import { JobRun, JobRunStatusType } from "src/jobs/types";

export const isSimulationSuccessful = (simulation: JobRun) => {
  return (
    simulation.status.type === JobRunStatusType.Completed &&
    simulation.simulation_job_run_details?.post_processing_status ===
      SimulationPostprocessingStatus.COMPLETED
  );
};

export const isSimulationFailed = (jobRun: JobRun) => {
  return (
    jobRun.status.type === JobRunStatusType.Failed ||
    jobRun.simulation_job_run_details?.post_processing_status ===
      SimulationPostprocessingStatus.FAILED
  );
};

export const isSimulationInProgress = (jobRun: JobRun) =>
  !isSimulationSuccessful(jobRun) && !isSimulationFailed(jobRun);

export const isSimulationComplete = (jobRun: JobRun) => {
  return isSimulationSuccessful(jobRun) || isSimulationFailed(jobRun);
};
